<div class="selected-profile">
  @if (imageKey !== null && activeSession !== null) {
    <div class="active-session-info">
      <p-avatar
        shape="circle"
        size="normal"
        [label]="activeSession.sessionInfo[labelKey][0].toUpperCase()"
        [image]="activeSession.sessionInfo[imageKey]"
      />
      <strong class="username">{{ activeSession.sessionInfo[labelKey] }}</strong>
    </div>
    <div class="active-session-actions">
      <p-menu #menu [model]="activeSessionActions" [popup]="true" [appendTo]="'body'" />
      <p-button (click)="menu.toggle($event)" link icon="pi pi-ellipsis-v" />
    </div>
  }
</div>
